var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerCurveAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 36,
    viewBox: "0 0 1440 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3273_1335)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3273_1335",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0V36H1440V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3273_1335)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3273_1335",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -651,
    y: 0,
    width: 2739,
    height: 257
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440.08 94.7683C1840.62 52.951 2088 327.189 2088 239.643C2088 107.292 1474.85 0 718.5 0C454.994 0 208.87 13.4322 0 36.0001C-390.66 78.2099 -651 153.401 -651 239.643C-651 324.848 -395.883 48.8471 -13.028 91.3392L-18.0044 157.143H1435.1L1440.08 94.7683Z",
    fill: "url(#paint0_linear_3273_1335)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3273_1335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0V161H1440V0Z",
    fill: "#FAF9F4"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3273_1335",
    x1: 718.5,
    y1: 0,
    x2: 718.5,
    y2: 257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3273_1335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerCurveAlt);
export default __webpack_public_path__ + "static/media/banner-curve-alt.bd5a3b443f4c6fdf7ff62497e7d65fd4.svg";
export { ForwardRef as ReactComponent };